const Polkadot = () => (
    <svg
        width='1327'
        height='1411'
        viewBox='0 0 1327 1411'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='663' cy='696' r='571' fill='white' />
        <path
            d='M663.193 445C749.35 445 819.193 404.482 819.193 354.5C819.193 304.518 749.35 264 663.193 264C577.037 264 507.193 304.518 507.193 354.5C507.193 404.482 577.037 445 663.193 445Z'
            fill='#E6007A'
        />
        <path
            d='M663.193 1128C749.35 1128 819.193 1087.48 819.193 1037.5C819.193 987.518 749.35 947 663.193 947C577.037 947 507.193 987.518 507.193 1037.5C507.193 1087.48 577.037 1128 663.193 1128Z'
            fill='#E6007A'
        />
        <path
            d='M446.008 570.734C489.043 496.199 488.763 415.473 445.384 390.427C402.006 365.382 331.954 405.501 288.92 480.036C245.886 554.571 246.165 635.297 289.544 660.343C332.923 685.388 402.974 645.269 446.008 570.734Z'
            fill='#E6007A'
        />
        <path
            d='M1037.38 912.159C1080.41 837.624 1080.16 756.911 1036.81 731.883C993.459 706.854 923.431 746.988 880.397 821.523C837.363 896.058 837.618 976.77 880.968 1001.8C924.317 1026.83 994.345 986.694 1037.38 912.159Z'
            fill='#E6007A'
        />
        <path
            d='M445.408 1001.78C488.787 976.732 489.066 896.006 446.032 821.471C402.998 746.936 332.946 706.817 289.568 731.862C246.189 756.908 245.91 837.634 288.944 912.169C331.978 986.704 402.029 1026.82 445.408 1001.78Z'
            fill='#E6007A'
        />
        <path
            d='M1036.85 660.363C1080.19 635.335 1080.45 554.622 1037.42 480.087C994.382 405.552 924.354 365.419 881.005 390.448C837.655 415.476 837.4 496.188 880.434 570.723C923.468 645.259 993.496 685.392 1036.85 660.363Z'
            fill='#E6007A'
        />
    </svg>
);

export default Polkadot;
